import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-paymentref-range',
  templateUrl: './paymentref-range.component.html',
  styleUrls: [],
  standalone: false
})
export class PaymentRefRangeComponent {
  @Input() from: any = null;
  @Input() to: any = null;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  constructor() {}
}
